"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HierarchyNavigationManager = void 0;
class HierarchyNavigationManager {
    constructor(flowName, childNavigationManager, parentNavigationManager) {
        this.flowName = flowName;
        this.childNavigationManager = childNavigationManager;
        this.parentNavigationManager = parentNavigationManager;
        this.isInternalNavigation = (flow) => {
            const pathSegments = flow.split('/').filter(segment => segment.length > 0);
            if (pathSegments.length > 0) {
                const firstSegment = pathSegments[0];
                return firstSegment === this.flowName;
            }
            return false;
        };
        this.goTo = (flow, data = {}) => {
            if (!this.isInternalNavigation(flow)) {
                this.parentNavigationManager.goTo(flow, data);
            }
            else {
                this.childNavigationManager.goTo(flow, data);
            }
        };
        this.replace = (flow, data = {}) => {
            if (!this.isInternalNavigation(flow)) {
                this.parentNavigationManager.goTo(flow, data);
            }
            else {
                this.childNavigationManager.goTo(flow, data);
            }
        };
    }
}
exports.HierarchyNavigationManager = HierarchyNavigationManager;
//# sourceMappingURL=HierarchyNavigationManager.js.map